import { useState } from 'react';
import styled from 'styled-components';
import { Fade as Hamburger } from 'hamburger-react';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';
import useDropdown from '../../../lib/hooks/useDropdown';
import { useBoards } from '../data';
import RegisteredUserOptions from './RegisteredUserOptions.jsx';
import BoardsArea from './BoardsArea.jsx';
import GuestOptions from './GuestOptions.jsx';

export default function MobileMenu({
  userType,
  guestUserResetPath,
  shouldConvertGuest,
  hideSignIn,
}) {
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();
  const { boards, isLoading, isIdle, fetchBoards } = useBoards();

  const { t } = useTranslation('header');
  const [dropdownContent, setDropdownContent] = useState('menuList');

  // hamburger-react renders the focusable role="button" itself, so let it
  // drive the menu; that also makes Enter open it from the keyboard.
  const toggleMenu = open => {
    setShowDropdown(open);
    setDropdownContent('menuList');
  };

  const onSwitchBoardsClick = () => {
    if (isIdle) {
      fetchBoards();
    }
    setDropdownContent('boardsArea');
  };

  const dropdownContents = {
    boardsArea: <BoardsArea isLoading={isLoading} boards={boards} />,
    menuList: (
      <List ref={dropdownRef}>
        {userType === 'guest' ? (
          <GuestOptions
            shouldConvertGuest={shouldConvertGuest}
            hideSignIn={hideSignIn}
            guestUserResetPath={guestUserResetPath}
          />
        ) : (
          <RegisteredUserOptions
            onSwitchBoardsClick={onSwitchBoardsClick}
            userType={userType}
          />
        )}
      </List>
    ),
  };

  return (
    <div style={{ position: 'relative' }}>
      <HamburgerContainer
        ref={buttonRef}
        onKeyDown={e => {
          if (e.key === ' ') {
            e.preventDefault();
            toggleMenu(!showDropdown);
          }
        }}
        dropdownOpen={showDropdown}
      >
        <Hamburger
          toggled={showDropdown}
          toggle={toggleMenu}
          label={t('headerButtons.menu')}
          hideOutline={false}
          color="#52575C"
          rounded
          size={20}
        />
      </HamburgerContainer>
      <div style={{ display: showDropdown ? 'block' : 'none' }}>
        {dropdownContents[dropdownContent]}
      </div>
    </div>
  );
}

const HamburgerContainer = styled.div`
  cursor: pointer;

  .hamburger-react:focus-visible {
    outline: 2px solid ${themeGet('colors.primary.100')};
    outline-offset: -6px;
    border-radius: 8px;
  }
  .hamburger-react:focus:not(:focus-visible) {
    outline: none;
  }
  margin-left: 5px;
  margin-right: -11px;

  ${themeGet('mediaQueries.forMediumUp')} {
    display: none;
  }
`;

const List = styled.ul`
  position: absolute;
  top: 38px;
  right: 0;
  border-radius: 8px;
  background: white;
  z-index: 3;
  width: 200px;
  font-weight: 500;
  font-size: 14px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  max-height: 80vh;
  overflow-y: auto;

  ${themeGet('mediaQueries.forMediumUp')} {
    top: 51px;
  }
`;
